import Vue from 'vue'
import VueRouter from 'vue-router'
import { useStore } from '@/store'
import { getUserData } from '@/utils/auth'
import extra from './extra'
import chart from './chart'

Vue.use(VueRouter)

const routes = [
  // ? We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: '/',
    redirect: to => {
      console.log('Redirect checking')
      const userData = getUserData('userData')
      console.log('userData', userData)
      if (!userData) {
        return { name: 'auth-login', query: to.query }
      }
      const store = useStore()
      if (store.getters.sysRoleMenus.length == 0) {
        console.log('userData.sysRoleMenuList', userData.sysRoleMenuList)
        store.dispatch('sysRoleMenus/updateMenus', userData.sysRoleMenuList).then(menus => {
          console.log('store menus', menus)
        })
      }
      const { userRecord } = userData
      if (userRecord && userRecord.sysUserRoles.length > 0) {
        const sysUserRole = userRecord.sysUserRoles[0]
        const coachRoleIds = [2, 3, 4]
        const managementRoleIds = [5, 7]

        // console.log('sysUserRole', sysUserRole)

        if (sysUserRole.sysRoleID === 6) {
          return { path: '/COACH_Create_Order' }
        } if (coachRoleIds.indexOf(sysUserRole.sysRoleID) >= 0) {
          return { path: '/COACH_Booking_Calendar' }
        } if (managementRoleIds.indexOf(sysUserRole.sysRoleID) >= 0) {
          return { path: '/MANAGE_Coach_Profiles' }
        } if (sysUserRole.sysRoleID === 1) {
          return { path: '/STUDENT_Booking_Calendar' }
        }

        return { path: '/STUDENT_PLAYGROUND' }
      }

      return { path: '/STUDENT_Profile' }
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error404.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: false,
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/Register.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },

  // {
  //   path: '/playground',
  //   name: 'Playground',
  //   component: () => import('@/views/pages/Playground.vue'),
  //   meta: {
  //     layout: 'content',
  //   },
  // },

]

routes.push(...extra)
routes.push(...chart)

const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes,
//   scrollBehavior() {
//     return { x: 0, y: 0 }
//   },
// })

// ? Router Before Each hook: https://router.vuejs.org/guide/advanced/navigation-guards.html
router.beforeEach((to, _, next) => {
  const userData = localStorage.getItem('userData')

  // console.log('beforeEach check userData', userData)
  if (to.name === 'OrderPrintView') {
    next()
  } else if (to.name !== 'auth-login' && !userData) {
    next({ name: 'auth-login' })
  } else {
    next()
  }

  // const isLoggedIn = userData && localStorage.getItem('accessToken') && localStorage.getItem('userAbility')

  // // console.log('userData',localStorage.getItem('userData'))
  // // console.log('accessToken',localStorage.getItem('accessToken'))
  // // console.log('userAbility',localStorage.getItem('userAbility'))
  // console.log('to',to)
  // // console.log('isLoggedIn',isLoggedIn)
  // // console.log('!canNavigate(to)',!canNavigate(to))
  // if (!canNavigate(to)) {
  //   // Redirect to login if not logged in
  //   if (!isLoggedIn) return next({ name: 'auth-login', query: { marketplace: to.query.marketplace } })

  //   // If logged in => not authorized
  //   return next({ name: 'misc-not-authorized' })

  //   // return next({ name: 'misc-not-authorized' })
  // }
  // Redirect if logged in
  // if (to.meta.redirectIfLoggedIn && isLoggedIn) {
  //   next('/')
  // }

  // return next()
})

export default router
